import { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import plantar from "../../assets/Principal/plantar.png";
import { useLang } from "../../context/LangContext";
import "./Navbar.css";

const sectionIds = ["about", "skills", "projects", "experience", "contact"];

export default function Navbar() {
  const { t, lang, toggle } = useLang();
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("");

  const links = [
    { href: "#about", label: t.nav.about },
    { href: "#skills", label: t.nav.skills },
    { href: "#projects", label: t.nav.projects },
    { href: "#experience", label: t.nav.experience },
    { href: "#contact", label: t.nav.contact },
  ];

  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") return undefined;

    const navbar = document.getElementById("navbar");
    const aboutSection = document.getElementById("about");

    function onScroll() {
      if (!aboutSection || !navbar) return;
      navbar.classList.toggle(
        "blur-background",
        aboutSection.getBoundingClientRect().top <= 0,
      );
    }

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") return undefined;
    if (typeof IntersectionObserver === "undefined") return undefined;

    const observers = [];
    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setActive(id);
        },
        { rootMargin: "-40% 0px -50% 0px", threshold: 0 },
      );
      obs.observe(el);
      observers.push(obs);
    });
    return () => observers.forEach((o) => o.disconnect());
  }, []);

  return (
    <header className="navbar" id="navbar">
      <div className="navbar-content">
        <a href="/" className="logo">
          <img
            src={plantar}
            alt="Alan Souza"
            className="logo-img"
            loading="lazy"
          />
          <span className="logo-text">Alan Souza._</span>
        </a>

        <ul className="nav-links">
          {links.map((link) => {
            const id = link.href.replace("#", "");
            return (
              <li key={link.href}>
                <a
                  href={link.href}
                  className={active === id ? "nav-active" : ""}
                >
                  {link.label}
                </a>
              </li>
            );
          })}
        </ul>

        <button
          className="lang-toggle"
          onClick={toggle}
          aria-label="Toggle language"
        >
          {lang === "pt" ? "🇧🇷 PT" : "🇺🇸 EN"}
        </button>

        <button
          className="nav-hamburger"
          aria-label={open ? "Fechar menu" : "Abrir menu"}
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      <nav className={`nav-mobile-menu${open ? " open" : ""}`}>
        <ul>
          {links.map((link) => {
            const id = link.href.replace("#", "");
            return (
              <li key={link.href}>
                <a
                  href={link.href}
                  className={active === id ? "nav-active" : ""}
                  onClick={() => setOpen(false)}
                >
                  {link.label}
                </a>
              </li>
            );
          })}
        </ul>
        <button className="lang-toggle lang-toggle--mobile" onClick={toggle}>
          {lang === "pt" ? "🇧🇷 PT" : "🇺🇸 EN"}
        </button>
      </nav>

      {open && <div className="nav-overlay" onClick={() => setOpen(false)} />}
    </header>
  );
}
